// extracted by mini-css-extract-plugin
module.exports = {"text":"ProductList_text__3pNmP","filter_button":"ProductList_filter_button__j3hU5","toolbar":"ProductList_toolbar__3AAr2"};